<template>
    <div class="certificatesInfo">
        <div class="certificatesInfo_title">
            <div class="certificatesInfo_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">相关学历及职业技能证书</span>
            </div>
            <div class="certificatesInfo_title_right">
                <el-button v-if="canEdit" size="mini" @click="addCertificatesInfo">添加</el-button>
            </div>
        </div>
        <el-table :data="vo.passenger.certificatesInfos" border="1px" style="width: 100%" class="certificatesInfosList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="certificatesName" label="证书名称" align="center" width="150px">
                <template slot-scope="scope">
                    <form-item
                        ref="certificatesName"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入证件名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '证书名称', propName: 'certificatesName', propType: 'String', textFormatter: 'textfield', valueMaxLength: 1000, valueMinLength: null, model: 'scope.row.certificatesName', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesSn" label="证件号码" align="center" width="160px">
                <template slot-scope="scope">
                    <form-item
                        ref="certificatesSn"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入证书号码', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '证书号码', propName: 'certificatesSn', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.certificatesSn', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="发证日期" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="certificatesDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '请选择发证日期', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '发证日期', propName: 'certificatesDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, tbFieldName: 'certificatesdate', iconName: 'rqxzk', model: 'scope.row.certificatesDate', option: [], formTdAlign: 'text-left', weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesType" label="证书类型" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="certificatesType"
                        :field="{
                            defaultValue: null,
                            elementCanEdit: '{${canEdit}}',
                            elementCssHeight: null,
                            elementCssWidth: null,
                            elementFormatter: '职业资格证书：职业资格证书\n信息技术服务管理认证：信息技术服务管理认证\n信息安全管理认证：信息安全管理认证\n计算机软件技术资格证书：计算机软件技术资格证书\n专业技能证书：专业技能证书\n学历证书：学历证书\n外语水平证书：外语水平证书\n项目管理专业认证：项目管理专业认证\n企业内部培训证书：企业内部培训证书\n其他专业认证：其他专业认证',
                            elementReadonly: 1,
                            elementType: 'select',
                            emptyMessage: '请选择证书类型',
                            errorMessage: null,
                            formTdAlign: 'text-left',
                            formTdColspan: 0,
                            isRequired: 0,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '证书类型',
                            propName: 'certificatesType',
                            propType: 'String',
                            textFormatter: null,
                            valueMaxLength: null,
                            valueMinLength: null,
                            model: 'scope.row.certificatesType',
                            option: [
                                { value: '职业资格证书', name: '职业资格证书' },
                                { name: '信息技术服务管理认证', value: '信息技术服务管理认证' },
                                { name: '信息安全管理认证', value: '信息安全管理认证' },
                                { name: '计算机软件技术资格证书', value: '计算机软件技术资格证书' },
                                { name: '专业技能证书', value: '专业技能证书' },
                                { name: '学历证书', value: '学历证书' },
                                { name: '外语水平证书', value: '外语水平证书' },
                                { name: '项目管理专业认证', value: '项目管理专业认证' },
                                { name: '企业内部培训证书', value: '企业内部培训证书' },
                                { name: '其他专业认证', value: '其他专业认证' }
                            ],
                            optionGenerateType: 0,
                            clearable: true,
                            filterable: false,
                            allowCreate: false,
                            readonlyShowChecked: 0
                        }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="issuingUnit" label="发证单位" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="issuingUnit"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入签发单位', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '发证单位', propName: 'issuingUnit', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'scope.row.issuingUnit', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="permanent" label="是否永久" align="center" width="150px">
                <template slot-scope="scope">
                    <form-item
                        ref="permanent"
                        :field="{
                            defaultValue: null,
                            elementCanEdit: '{${canEdit}}',
                            elementCssHeight: null,
                            elementCssWidth: null,
                            elementFormatter: '0：否\n1：是',
                            elementReadonly: 1,
                            elementType: 'radio',
                            emptyMessage: '请选择是否永久',
                            errorMessage: null,
                            formTdAlign: 'text-left',
                            formTdColspan: 0,
                            isRequired: 0,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '是否永久',
                            propName: 'permanent',
                            propType: 'Short',
                            textFormatter: null,
                            valueMaxLength: null,
                            valueMinLength: null,
                            model: 'scope.row.permanent',
                            option: [
                                { value: '0', name: '否' },
                                { value: '1', name: '是' }
                            ],
                            optionGenerateType: 0,
                            clearable: true,
                            filterable: false,
                            allowCreate: false
                        }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="expiredDate" label="到期日期" align="center" width="180px">
                <template slot-scope="scope">
                    <span v-if="scope.row.permanent === 0">
                        <form-item
                            ref="expiredDate"
                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '到期日期', propName: 'expiredDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, tbFieldName: 'expireddate', iconName: 'rqxzk', model: 'scope.row.expiredDate', option: [], formTdAlign: 'text-left', weekday: 0 }"
                            :vo="scope.row"
                            :can-edit="canEdit"
                        />
                    </span>
                    <span v-else>永久</span>
                </template>
            </el-table-column>
            <el-table-column prop="certificatesFileName" label="证书文件" align="left">
                <template slot-scope="scope">
                    <!-- 附件上传 -->
                    <div v-if="canEdit" style="text-align: center" @click="uploadChange(scope.row)">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="证书文件" style="display: flex; align-items: center; justify-content: center">
                            <div v-if="scope.row.certificatesFileName" class="attachment-link-wrapper">
                                <el-link :title="scope.row.certificatesFileName" class="attachment-link" @click="download(scope.row)">
                                    {{ scope.row.certificatesFileName }}
                                </el-link>
                            </div>
                            <el-upload ref="uploadRef" style="min-width: 30px" class="upload-demo" action="#" :on-change="fileChange" :auto-upload="false" :on-remove="handleRemove" :multiple="false" :file-list="scope.row.passenger.attachments" :show-file-list="false">
                                <div style="color: #409eff">上传</div>
                            </el-upload>
                        </ValidationProvider>
                    </div>
                    <div v-else @click="uploadChange(scope.row)">
                        <div class="attachment-link-wrapper">
                            <el-link v-if="scope.row.certificatesFileName" :title="scope.row.certificatesFileName" class="attachment-link" @click="download(scope.row)">
                                {{ scope.row.certificatesFileName }}
                            </el-link>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'CertificatesInfo',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    updated() {},
    methods: {
        addCertificatesInfo() {
            this.$http({
                method: 'POST',
                url: '/rsgl/certificatesInfo/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.certificatesInfos.push(res.body.vo)
                }
            })
        },
        download(row) {
            window.open('apigw/rsgl/certificatesInfo/download?id=' + row.id + '&dataField=certificatesEnclosure&nameField=certificatesFileName')
        },
        fileChange(files, fileList) {
            fileList[0] = files
            if (fileList.length > 0) {
                console.log(files, fileList)
                fileList[0].rowId = this.uploadRow.id
                this.vo.passenger.certificatesInfos.forEach((item) => {
                    if (this.uploadRow.id === item.id) {
                        item.certificatesFileName = fileList[0].name
                    }
                })
                this.uploadAttachList.push(fileList[0])

                console.log(this.vo.passenger.certificatesInfos, 'this.vo.passenger.certificatesInfos')
                console.log(this.uploadAttachList, 'this.uploadAttachList')
            }
        },
        // 当前操作上传附件栏
        uploadChange(row) {
            this.uploadRow = row
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.certificatesInfos = this.vo.passenger.certificatesInfos.filter((item) => item.id !== row.id)
        }
    }
}
</script>

<style scoped lang="scss">
.certificatesInfo_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
</style>
